const baseURL = '';
const bucket = 'rcmtoss'
const officeServeUrl = 'https://view.officeapps.live.com/op/view.aspx'
let pdfServeUrl = '/webPublic/pdf/web/viewer.html'  

// envType 对应的值  local dev test prod
const envType = process.env.VUE_APP_SERVER_ENV
const yyySetType = 1
const yyyNum = "6004000001"
const proxyPubUrl = "http://public.bjsihao.cn/"
let proxyUrl, socketUrl, pathName, curEnvType;  //
const platformType = 1  // 1 后台 2 手机端网页 3 客户端
switch(envType){
    case 'test':
        proxyUrl = "http://101.200.212.33:8765/"
        proxyUrl = "https://test-v1-manage.bjsihao.cn/"
        socketUrl = "https://socket.liusandao.top"
        pdfServeUrl = '/webPublic/pdf/web/viewer.html'  
        socketUrl = ""
        pathName = "sockettest"
        curEnvType = 12
        break
    case "dev":
        proxyUrl = "http://101.200.212.33:8764/"
        proxyUrl = "https://dev-v1-manage.bjsihao.cn/"
        //proxyUrl = "http://192.168.1.73:8764"
        //proxyUrl = 'http://192.168.1.13:8764/'
        //socketUrl = "https://socket.liusandao.top"
        //socketUrl = "http://localhost:3008"
        //socketUrl = ""
        pdfServeUrl = '/webPublic/pdf/web/viewer.html'  
        pathName = "socketdev"
        curEnvType = 13
        break
    case 'local':
        proxyUrl = "http://101.200.212.33:8764/"
        //proxyUrl = "http://192.168.1.138:8764"
        proxyUrl = "https://dev-v1-manage.bjsihao.cn/"
        socketUrl = "http://39.98.157.218:3008"
        socketUrl = ""
        pdfServeUrl = '/webPublic/pdf/web/viewer.html'  
        pathName = "socketdev"
        curEnvType = 13
        break
    case 'prod':
        proxyUrl = 'http://101.200.212.33:8766/'
        proxyUrl = "https://v1-manage.bjsihao.cn/"
        //proxyUrl = "https://v1-manage.bjsihao.cn/"
        socketUrl = "https://socket.liusandao.top"
        socketUrl = ""
        pdfServeUrl = '/webPublic/pdf/web/viewer.html'  
        pathName = "socketprod"
        curEnvType = 11
        break
}
const bwActivityUrlPrefix = "https://v1-manage.bjsihao.cn"
module.exports = {
    baseURL,
    bucket,
    officeServeUrl,
    pdfServeUrl,
    envType,
    proxyUrl,
    proxyPubUrl,
    socketUrl,
    pathName,
    yyySetType,
    yyyNum,
    ossUrl: "https://rcmtoss.oss-cn-beijing.aliyuncs.com",
    parentDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/parentDefault.png",
    studentDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/studentDefault.png",
    teacherDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/teacherDefault.png",
    eduDefaultImg: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/teacherManagerDefault.png",
    fileLearnDefaultCover: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/file-learn-cover.png",
    videoLearnDefaultCover: "https://rcmtoss.oss-cn-beijing.aliyuncs.com/default/video-learn-cover.png",
    curEnvType,
    platformType,
    /* 小程序相关详情图片 */
    activity1And3DetailUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/1+3-detail.png`,
    activity1And3HeadUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/1+3-head.png`,
    enCourseDetailUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/en-course-detail.png`,
    enCourseHeadUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/en-course-head.png`,
    psyCourseDetailUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/psy-course-detail.png`,
    psyCourseHeadUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/psy-course-head.png`,
    trialCourseDetailUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/trial-course-detail.png`,
    trialCourseHeadUrl: `${bwActivityUrlPrefix}/wxmini/bwactivity/image/trial-course-head.png`,
}